module.exports = __webpack_public_path__ + "static/media/siren-on.7972020a.svg";